<template>
  <DrawHistoryActivityDetail />
</template>

<script>
import DrawHistoryActivityDetail from "../components/place/drawactivity/HistoryActivityDetail.vue";
export default {
  data() {
    return {};
  },
  components: {
    DrawHistoryActivityDetail,
  },
};
</script>
<style lang="" scoped></style>
